module.exports = __webpack_public_path__ + "static/dema-logo-31529358d80358acc427558468e87910.png";